// extracted by mini-css-extract-plugin
export default {"left":"style_left__qmctZ","right":"style_right__7uVhf","rightIcon":"style_rightIcon__OMAmu","bold":"style_bold__TMo2+"};